export const SESSION_LIFECYCLE_STATES = Object.freeze({
    unauthenticated: "unauthenticated",
    identityVerified: "identity_verified",
    accessResolved: "access_resolved",
    portalSessionActive: "portal_session_active",
    portalSessionExpired: "portal_session_expired",
    portalSessionRevoked: "portal_session_revoked",
    logoutInProgress: "logout_in_progress",
    loggedOut: "logged_out",
});

export const SESSION_REASON_CODES = Object.freeze({
    invalid: "session_invalid",
    expired: "session_expired",
    revoked: "session_revoked",
    accessChanged: "access_changed",
    unableToValidate: "session_unable_to_validate",
});
